import type { AppAction } from "@/types";

export const merchantOfRecordOrderDocumentUploaded: AppAction<{
    emit: (event: "order-document-upload-button-click", ...args: any[]) => void;
}> = async (args) => {
    args.emit("order-document-upload-button-click");
    return true;
};
